// EmployeeEditor.jsx

import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardHeader,
  Table,
  Label,
  Button,
} from "reactstrap";
import Stepper from "react-stepper-horizontal";
import { useFormik } from "formik";
import CreateButtons from "../Button/CreateButtons";
import months from "../data/months";
import MonthlyReportServices from "../../../../services/COOPServices/MonthlyReportServices/MonthlyReportServices";
import ReportTypeServices from "../../../../services/COOPServices/ReportTypeServies/ReportTypeServices";
import SubHeadingServices from "../../../../services/COOPServices/SubHeadingServices/SubHeadingServices";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";
import CustomSelect from "../../../../Components/Common/CustomSelect/CustomSelect";
import Breadcrumbs from "../../../../Components/Common/BreadCrumbs";
import steps from "../data/steps";
import ModalReport from "../Modal/modal";
import TableComponent from "../components/TableComponent";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import CreateReportValidation from "../../../../validation/CreateReportValidation";
import LanguageToggle from "../LanguageToggleButton/LanguageToggle";

const CreateReport = () => {
  const [headings, setHeadings] = useState();
  console.log("🚀 ~ CreateReport ~ headings:", headings);
  const [reportTypeOption, setReportTypeOption] = useState();
  const [report, setReport] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      reportTypeId: "",
      year: "",
      month: "",
      reportTxnsDummy: [],
      reportTxns: [
        {
          reportSubTxnDtos: [
            {
              subTxnDtos: [
                // Initialize with default values if necessary
              ],
            },
          ],
        },
      ],
    },
    validationSchema: CreateReportValidation,
    onSubmit: async (values) => {
      const formattedData = {
        ...values,
        reportTypeId: values.reportTypeId?.value,
        year: values.year?.value,
        month: values.month?.value,
      };
      console.log("🚀 ~ onSubmit: ~ formattedData:", formattedData);
      try {
        const response = await MonthlyReportServices.create(formattedData);
        toast.success("Report Created Successfully");
        navigate(`/draft-report/${response.reportId}`);
      } catch (error) {
        console.log("🚀 ~ onSubmit:async ~ error:", error);
      }
    },
  });

  const fetchReportTypeOption = async () => {
    try {
      const response = await ReportTypeServices.getList({
        pageNumber: 1,
        pageSize: 100,
      });
      const temp = response?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setReportTypeOption(temp);
    } catch (error) {
      console.log("🚀 ~ fetchReportTypeOption ~ error:", error);
    }
  };

  const fetchheadings = async () => {
    try {
      const response = await SubHeadingServices.getDisplayList();

      setHeadings(response);
    } catch (error) {
      console.log("🚀 ~ fetchheadings ~ error:", error);
    }
  };

  const fetchReport = async () => {
    try {
      const response = await MonthlyReportServices.getDetail({ reportId: id });
      setReport(response);
    } catch (error) {
      console.log("🚀 ~ fetchReport ~ error:", error);
    }
  };

  useEffect(() => {
    fetchReportTypeOption();
    fetchheadings();
  }, []);

  const breadcrumbItems = [
    { title: "Reports", link: "/report" },
    { title: "Create New Report" },
  ];
  console.log("formik.values", formik.values);

  return (
    <React.Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Container fluid>
          <div className="">
            <div className="page-content">
              <Row>
                <Col>
                  <Row className="justify-content-between ">
                    <Col>
                      <Breadcrumbs items={breadcrumbItems} />
                    </Col>
                    <Col className="text-end">
                      <button
                        style={{
                          border: "none",
                          marginRight: "15px",
                          padding: "0",
                        }}
                      >
                        <LanguageToggle
                          toggleVisibility={toggleVisibility}
                          setIsVisible={setIsVisible}
                          isVisible={isVisible}
                        />
                      </button>
                    </Col>
                  </Row>
                  <Row style={{ paddingRight: "17px" }}>
                    <CreateButtons
                      toggleVisibility={toggleVisibility}
                      isVisible={isVisible}
                      setIsVisible={setIsVisible}
                      resetForm={formik.resetForm}
                    />
                  </Row>
                  <Row className="px-2">
                    <Col lg={6}>
                      <Row>
                        <Card className="mt-4">
                          <CardBody className="mt-2">
                            {report?.submissionNum && (
                              <h6 className="fw-bold">
                                submission no: {report?.submissionNum}
                              </h6>
                            )}
                            <div className="card-width-full">
                              <div className="d-flex">
                                <div className="mt-2 me-3 col">
                                  <CustomInput
                                    required
                                    label={"Name"}
                                    handleBlur={formik.handleBlur}
                                    handleChange={formik.handleChange}
                                    id={"name"}
                                    name={"name"}
                                    placeholder={"Report Name"}
                                    touched={formik.touched.name}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                  />
                                </div>
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`reportTypeId`}
                                    name={`reportTypeId`}
                                    label={"Report Type"}
                                    options={reportTypeOption}
                                    placeholder={"Select Report Type"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.reportTypeId &&
                                      formik.touched?.reportTypeId
                                    }
                                    value={formik.values.reportTypeId}
                                    errors={
                                      formik.errors.reportTypeId &&
                                      formik.errors?.reportTypeId.value
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="py-1">
                              <div className="d-flex">
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`year`}
                                    name={`year`}
                                    label={"Select Year"}
                                    options={[
                                      {
                                        label: "2077",
                                        value: 2077,
                                      },
                                      {
                                        label: "2078",
                                        value: 2078,
                                      },
                                      {
                                        label: "2079",
                                        value: 2079,
                                      },
                                      {
                                        label: "2080",
                                        value: 2080,
                                      },
                                      {
                                        label: "2081",
                                        value: 2081,
                                      },
                                      {
                                        label: "2082",
                                        value: 2082,
                                      },
                                      {
                                        label: "2083",
                                        value: 2083,
                                      },
                                    ]}
                                    placeholder={"Select Year"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.year &&
                                      formik.touched?.year
                                    }
                                    value={formik.values.year}
                                    errors={
                                      formik.errors.year &&
                                      formik.errors?.year.value
                                    }
                                  />
                                </div>
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`month`}
                                    name={`month`}
                                    label={"Select Month"}
                                    options={months}
                                    placeholder={"Select Month"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.month &&
                                      formik.touched?.month
                                    }
                                    value={formik.values.month}
                                    errors={
                                      formik.errors.month &&
                                      formik.errors?.month.value
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                    </Col>
                    <Col lg={6} className="px-4 mt-4">
                      <Card
                        style={{
                          width: "100%",
                          height: "223px",
                          paddingTop: "60px",
                        }}
                      >
                        <Stepper
                          steps={steps}
                          activeStep={0}
                          className=" pt-5 fs-10 mx-auto "
                          activeColor="green"
                          completeColor="green"
                          toggleVisibility={toggleVisibility}
                          isVisible={isVisible}
                          setIsVisible={setIsVisible}
                        />
                      </Card>
                    </Col>
                  </Row>

                  <Row className="px-2">
                    <Row>
                      <Card className="p-0">
                        <CardBody className="pt-1">
                          {headings?.mainHeadings
                            // ?.slice(0, 3)
                            ?.map((item, index) => {
                              return (
                                <TableComponent
                                  report={report}
                                  mainHeading={item}
                                  headings={item?.headings}
                                  index={index}
                                  formik={formik}
                                  onWheel={false}
                                  isVisible={isVisible}
                                  setIsVisible={setIsVisible}
                                  toggleVisibility={toggleVisibility}
                                />
                              );
                            })}
                        </CardBody>
                      </Card>
                    </Row>
                  </Row>
                </Col>
              </Row>

              <Row style={{ paddingRight: "17px" }} className="mb-4">
                <CreateButtons
                  toggleVisibility={toggleVisibility}
                  isVisible={isVisible}
                  setIsVisible={setIsVisible}
                  resetForm={formik.resetForm}
                />
              </Row>
            </div>
          </div>
        </Container>
      </form>
    </React.Fragment>
  );
};

export default CreateReport;
